/* ==========================================================================
   Phone display helper
   ========================================================================== */

/**
 * Format a stored phone/fax number for display: a 10-digit North American
 * number (optionally with a leading 1) becomes "(555) 123-4567". Anything else
 * is shown as stored — numbers entered by the pharmacy or the API aren't
 * always digits-only.
 */
export function formatPhoneForDisplay(value: string | null | undefined): string | null {
  if (!value) return null
  let digits = value.replace(/\D/g, '')
  if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1)
  if (digits.length !== 10) return value
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
}
